/* eslint-disable no-unused-vars */
import { axios } from './index'
import { mappingParamSearch } from '@/utils/page/menuSearch'
import cloneDeep from 'lodash/cloneDeep'
import { forEach } from 'lodash'
const resource = '/v1/stay'
export default {
  async searchPlan(page, size, menuNo, params = {}) {
    const data = cloneDeep(params)
    const redundant = [
      'category',
      'orderBy',
      'keyword',
      //'stayNights',
      'rooms',
      'areaLrgClassCd',
      'areaMidClassCd',
      'areaSmlClassCd',
      'areaDtlClassCd'
    ]
    let queryParams = {}
    forEach(data, (value, key) => {
      if (!redundant.includes(key)) {
        queryParams[key] = value
      }
    })
    mappingParamSearch(queryParams, menuNo)

    return new Promise((resolve, reject) => {
      axios.post(`${resource}/search/plan?page=${page}&size=${size}`, queryParams).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },

  async getPlanDetail(menuNo, planId, roomId, queryParams = {}) {
    // eslint-disable-next-line no-sparse-arrays
    const supportQueryParams = [
      'priceDiv',
      'crmFlag',
      'loginFlag',
      'roomCnt',
      'adultHeadCnt',
      'exUpperGradesHeadCnt',
      'exLowerGradesHeadCnt',
      'designatedMo',
      'youjiAHeadCnt',
      'youjiBHeadCnt',
      'youjiCHeadCnt',
      'youjiDHeadCnt',
      'designatedMo',
      'checkInDay',
      'checkOutDay'
    ]
    const params = {}
    Object.keys(queryParams).forEach((key) => {
      if (
        supportQueryParams.includes(key) &&
        queryParams[key] !== undefined &&
        queryParams[key] !== null
      ) {
        params[key] = queryParams[key]
      }
    })
    return new Promise((resolve, reject) => {
      // api/menus/1/plans/1/rooms/1?companyCd=1
      axios
        .get(`${resource}/menu/${menuNo}/plans/${planId}/rooms/${roomId}`, {
          params,
          loading: false
        })
        .then(
          (response) => {
            resolve(response.data)
          },
          (error) => {
            reject(error)
          }
        )
    })
  },

  async getPlanDetailForSearch(menuNo, planId, roomId, queryParams = {}) {
    // eslint-disable-next-line no-sparse-arrays
    const supportQueryParams = [
      'priceDiv',
      'crmFlag',
      'loginFlag',
      'roomCnt',
      'adultHeadCnt',
      'exUpperGradesHeadCnt',
      'exLowerGradesHeadCnt',
      'designatedMo',
      'youjiAHeadCnt',
      'youjiBHeadCnt',
      'youjiCHeadCnt',
      'youjiDHeadCnt',
      'designatedMo',
      'checkInDay',
      'checkOutDay'
    ]
    const params = {}
    Object.keys(queryParams).forEach((key) => {
      if (
        supportQueryParams.includes(key) &&
        queryParams[key] !== undefined &&
        queryParams[key] !== null
      ) {
        params[key] = queryParams[key]
      }
    })
    return new Promise((resolve, reject) => {
      // api/menus/1/plans/1/rooms/1?companyCd=1
      axios
        .get(`${resource}/menu/${menuNo}/plans/${planId}/rooms/${roomId}/stay-search`, {
          params,
          loading: false
        })
        .then(
          (response) => {
            resolve(response.data)
          },
          (error) => {
            reject(error)
          }
        )
    })
  },

  async getPlanDetailTour(menuNo, planId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${resource}/menu/${menuNo}/plans/${planId}/tour`, { loading: false })
        .then(
          (response) => {
            resolve(response.data)
          },
          (error) => {
            reject(error)
          }
        )
    })
  },
  async getDPPlanDetail(menuNo, planId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${resource}/dp/menus/${menuNo}/plans/${planId}`, { loading: false })
        .then(
          (response) => {
            resolve(response.data)
          },
          (error) => {
            reject(error)
          }
        )
    })
  },

  async getVacancyCalendar({ menuNo, planId, roomId, queryParams = {} }) {
    const defaultParams = {
      companyCd: null,
      checkInDay: null,
      checkOutDay: null,
      roomCnt: null,
      adultHeadCnt: null,
      exUpperGradesHeadCnt: '0',
      exLowerGradesHeadCnt: '0',
      youjiAHeadCnt: '0',
      youjiBHeadCnt: '0',
      youjiCHeadCnt: '0',
      youjiDHeadCnt: '0'
    }
    return new Promise((resolve, reject) => {
      const params = { ...defaultParams, ...queryParams }
      axios
        .get(
          `${resource}/menu/${menuNo}/plans/${planId}/rooms/${roomId}/vacancy-calendar`,
          { params }
        )
        .then(
          (res) => {
            resolve(res.data)
          },
          (error) => {
            reject(error)
          }
        )
    })
  },

  async sendMailToAddress(data) {
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/menu/share`, data).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },

  async putPay(params) {
    const data = {
      payMethodDiv: '10',
      menuNm: params.menuNm,
      billingAmount: params.billingAmount
    }
    return new Promise((resolve, reject) => {
      axios.put(`${resource}/order/select_pay`, data).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },

  // async putPay(params) {
  //   // const payMethodDiv = params.payMethodDiv
  //   const menuNm = params.menuNm
  //   const billingAmount = params.billingAmount
  //   return new Promise((resolve, reject) => {
  //     axios.put(`/order/select_pay?menuNm=${menuNm}&billingAmount=${billingAmount}`).then(
  //       (res) => {
  //         resolve(res.data)
  //       },
  //       (error) => {
  //         reject(error?.error)
  //       }
  //     )
  //   })
  // },

  async getGrantedBenepoStay({ menuNo, planId, billingAmount, params }) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${resource}/menu/${menuNo}/plans/${planId}/amount/${billingAmount}/granted-benepo-stay`, {params}
        )
        .then(
          (res) => {
            resolve(res.data)
          },
          (error) => {
            reject(error)
          }
        )
    })
  },
  async checkRoomLimit(params) {
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/order/limit-check-stay`, params).then(
        (response) => {
          resolve(response.status)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },

  async getStayParams({ menuNo, planId, roomId, params }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${resource}/menu/${menuNo}/plans/${planId}/rooms/${roomId}/stay-param`, {
          params
        })
        .then(
          (response) => {
            resolve(response.data)
          },
          (error) => {
            reject(error?.error)
          }
        )
    })
  },

  async getServiceDetail(menuNo) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/menu/${menuNo}/equipments-services`).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error.data)
        }
      )
    })
  },

  async getRakutenVacancy(params) {
    return axios.get(`${resource}/order/calendar-rakuten`, { params })
  },
}
